<template>
  <div class="admin-data-report-modal-body">
    <h1 class=" mb-4">
        {{$t('message.admDataReport.message.generateReport')}}
    </h1>

    <div class="admin-data-report-modal-body-inputs">
      <app-box-wrapper :data-label="$t('message.generics.message.startDate')"
                       data-icon="mdi-calendar-range">

        <app-date-picker v-model="start" />

      </app-box-wrapper>

      <app-box-wrapper :data-label="$t('message.generics.message.endDate')"
                       data-icon="mdi-calendar-range">

        <app-date-picker v-model="end" />

      </app-box-wrapper>
    </div>

    <button class="btn btn-primary btn-extra-round"
            @click="generateReport">
        {{$t('message.admDataReport.message.start')}}
    </button>

  </div>
</template>

<script>
  import AppBoxWrapper from '@components/BoxWrapper'
  import AppDatePicker from '@components/DatePicker'
  import moment from 'moment'
  import EventBus from '@packages/event-bus'

    export default {
        components: {
          AppDatePicker,
          AppBoxWrapper
        },

        data() {
            return {
              start: moment().subtract(31, 'days').format('YYYY-MM-DD'),
              end: moment().subtract(1, 'days').format('YYYY-MM-DD')
            }
        },

        mixins: [],

        methods: {
          async generateReport() {
            await this.$api.report.generate({
              start: this.start,
              end: this.end
            })

            this.$emit('started')

            EventBus.$emit('ADMIN_DATA_REPORT_STARTED');
          },
        },

        mounted() {
        },

        beforeDestroy() {

        }
    }
</script>

<style lang="scss" scoped>
.admin-data-report-modal-body {
  padding: 20px;

  h1 {
    font-weight: 600;
    text-align: center;
  }

  .admin-data-report-modal-body-inputs {
    display: flex;
    margin-bottom: 40px;
  }

  .btn {
    display: block;
    margin: 0 auto;
    min-width: 200px;
  }
}
</style>
